import { Menu, MenuItem, styled, Typography } from "@mui/material"
import React, { useState } from "react"

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: "16px",
  borderBottom: `1px solid ${theme.palette.primary.hover}`,
  "&:hover": {
    backgroundColor: theme.palette.background.default
  },
  "&.Mui-selected": {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  "&:last-of-type": {
    borderBottom: "none"
  }
}))

const Dropdown = ({
  value = "",
  menuItems,
  onMenuOpenClose = () => {},
  onChange = () => {},
  children
}) => {
  const [anchorEl, setAnchorEl] = useState(false)
  const openMenu = Boolean(anchorEl)

  const handleMenuClose = () => {
    setAnchorEl(null)
    onMenuOpenClose(false)
  }

  const handleMenuOpen = (e) => {
    setAnchorEl(e.currentTarget)
    onMenuOpenClose(true)
  }

  const handleMenuItemClick = (val) => {
    onChange(val)
    handleMenuClose()
  }

  return (
    <>
      <span onClick={handleMenuOpen}>{children}</span>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        PaperProps={{
          sx: (theme) => ({
            marginTop: "-2px",
            border: `1px solid ${theme.palette.white.main}`,
            borderRadius: "0px 0px 12px 12px",
            backgroundColor: theme.palette.background.default,
            "& .MuiList-root": {
              backgroundColor: theme.palette.background.default,
              width: "225px",
              boxSizing: "border-box"
            }
          })
        }}>
        {menuItems.map((menu, index) => (
          <StyledMenuItem
            selected={value === menu.value}
            onClick={() => handleMenuItemClick(menu.value)}
            key={index}>
            <Typography variant="body2Regular">{menu.label}</Typography>
          </StyledMenuItem>
        ))}
      </Menu>
    </>
  )
}

export default Dropdown
